import { requestPost, requestGet } from "../utils/request.ts";

export interface PaymentResponse {
    code: number;
    pay_url?: string;
    order_id?: string;
    msg?: string;
    type?: string;
    jsapi_params?: any;
    need_oauth?: boolean;
    appid?: string;
}

export interface SubscriptionProduct {
    id: number;
    name: string;
    price: string;
    currency: string;
    duration_days: number;
    product_type: "camera" | "user" | "member";
    description: string;
}

export const getProducts = async (): Promise<{ products: SubscriptionProduct[] }> => {
    return await requestGet<{ products: SubscriptionProduct[] }>("/v2/payment/products");
};

export const createPayment = async (cameraId: number | null | undefined, productId: number, paymentMethod: string = 'alipay', code?: string): Promise<PaymentResponse> => {
    return await requestPost<PaymentResponse>("/v2/payment/create", {
        camera_id: cameraId,
        product_id: productId,
        payment_method: paymentMethod,
        code: code
    });
};

export const getPaymentMethods = async (): Promise<{ methods: string[] }> => {
    return await requestGet<{ methods: string[] }>("/v2/payment/methods");
};
